var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2442.4 2237",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 1628.6L862.5 221.9l703.7 406.3-812 1406.7-703.8-406.3z",
    fill: "#fbbc04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2385.1 1623.7L1572.5 216.5C1467.6 18.1 1221.8-57.7 1023.4 47.2S749.3 397.9 854.1 596.3c4.6 8.7 9.5 17.2 14.7 25.6l812.6 1407.2c109.6 195.8 357.2 265.7 553 156.1s265.7-357.2 156.1-553c-1.8-3.2-3.6-6.3-5.4-9.4v.9z",
    fill: "#4285f4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 406.3,
    cy: 1828.6,
    r: 406.3,
    fill: "#34a853"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNDQyLjQgMjIzNyI+PHBhdGggZD0iTTUwLjQgMTYyOC42TDg2Mi41IDIyMS45bDcwMy43IDQwNi4zLTgxMiAxNDA2LjctNzAzLjgtNDA2LjN6IiBmaWxsPSIjZmJiYzA0Ii8+PHBhdGggZD0iTTIzODUuMSAxNjIzLjdMMTU3Mi41IDIxNi41QzE0NjcuNiAxOC4xIDEyMjEuOC01Ny43IDEwMjMuNCA0Ny4yUzc0OS4zIDM5Ny45IDg1NC4xIDU5Ni4zYzQuNiA4LjcgOS41IDE3LjIgMTQuNyAyNS42bDgxMi42IDE0MDcuMmMxMDkuNiAxOTUuOCAzNTcuMiAyNjUuNyA1NTMgMTU2LjFzMjY1LjctMzU3LjIgMTU2LjEtNTUzYy0xLjgtMy4yLTMuNi02LjMtNS40LTkuNHYuOXoiIGZpbGw9IiM0Mjg1ZjQiLz48Y2lyY2xlIGN4PSI0MDYuMyIgY3k9IjE4MjguNiIgcj0iNDA2LjMiIGZpbGw9IiMzNGE4NTMiLz48L3N2Zz4=";
export { SvgGoogleAds as ReactComponent };